module.exports = __webpack_public_path__ + "static/media/karakter-kerja.00723460.svg";